/* eslint-disable */

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import apiInstance from "../utils/api";
import Swal from "sweetalert2";
const ConfirmImageUpdateDialog = (props) => {
    const testData = props.testSelectData
    const testID = props.testSelectID
    const subTest = props.subTest
    // console.log(testData, 'testData')
    // console.log(subTest, 'sub')
    const handleTestSelection = (event, id) => {
        // console.log(event, 'event')
        // console.log(id, 'id')
        let newData = [];
        if (event?.name.subTestFlag) {
            subTest.map(data => {
                if (data.tsid === id) {
                    newData.push(data)
                }
            })
            // console.log(newData, 'id')
            const data = {
                testSelectionID: id,
                voucherID: props.TestVou_id,
                subTest: newData,
                status: props.voucherLists.map((i) => (i.name.subTestFlag === true)) ? "Finished" : "In Progress",

            };
            // console.log(data, 'data');
            // const formData = new FormData();

            // formData.append("testSelectionID", id);
            // formData.append("voucherID", TestVou_id);
            // image && image.map((i) => (
            //   formData.append("image", i)
            // ));

            // formData.append("subTest", newData);
            // formData.append("status", voucherLists.map((i) => (i.name.subTestFlag === true)) ? "Finished" : "In Progress");
            apiInstance
                .put(

                    "vouchers/subtests",

                    data, {
                    headers: { 'Content-Type': 'application/json' }
                }
                )
                .then(function (response) {
                    props.close()
                    Swal.fire({
                        title: "Success",
                        text: "successfully Updated!",
                        icon: "success",
                        confirmButtonText: "OK",
                    })
                    // console.log(response.data, 'data')
                    //  setTestID([testID, response.data.data]);
                })
                .catch(function (err) {
                    Swal.fire({
                        title: "Error",
                        text: err.response.data.message,
                        icon: "error",
                        confirmButtonText: "CANCEL",
                    })
                });

        } else {
            // console.log(event._id, 'event._id')
            // console.log(props.image, 'image')
            // const findItems = props.voucherLists.find(el => el._id === event._id)
            // console.log(testData, 'testData')
            const data = {
                testSelectionID: event._id,
                voucherID: props.TestVou_id,
                result: testData?.result,
                remark: testData?.remark,
                img: props.image,

            };

            // const formData = new FormData();

            // formData.append("testSelectionID", event._id);
            // formData.append("voucherID", TestVou_id);
            // image.forEach(item => {
            //   formData.append('image', item) // Assuming 'item' is a File object
            // })

            // formData.append("result", result);
            // formData.append("remark", remark);
            // const config = {
            //   headers: { 'Content-Type': 'application/json' }
            // }
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
            apiInstance
                .put(
                    "vouchers/document",
                    data,
                    config
                )
                .then(function (response) {
                    props.close()
                    Swal.fire({
                        title: "Success",
                        text: "successfully Updated!",
                        icon: "success",
                        confirmButtonText: "OK",
                    })
                    //  setTestID([testID, response.data.data]);
                })
                .catch(function (err) {
                    Swal.fire({
                        title: "Error",
                        text: '',
                        icon: "error",
                        confirmButtonText: "CANCEL",
                    })
                });

        }



    };

    return (
        <div style={{ minWidth: "1000px" }}>

            <Dialog open={props.open} onClose={props.close} fullWidth maxWidth='sm'>
                <DialogTitle className="text-left">
                    <u>Confirm to update</u>
                </DialogTitle>
                <DialogContent>
                    <span>Are you sure to update?</span>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.close}>Cancel</Button>
                    <Button onClick={() => handleTestSelection(testData, testID)}>Confirm</Button>
                </DialogActions>
            </Dialog>

        </div>
    );
};

export default ConfirmImageUpdateDialog;
